import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { LoginWorkspaceHostComponent } from '../core/login-workspace/login-workspace-host.component';
import { ProductionWorkspaceHostComponent } from '../core/production-workspace/production-workspace-host.component';
import { SamplingWorkspaceHostComponent } from '../core/sampling-workspace/sampling-workspace-host.component';
import { CurrentUserResolverService } from '../shared/resolvers/current-user-resolver.service';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: 'workspace_callback',
          component: LoginWorkspaceHostComponent,
          resolve: {
            currentUser: CurrentUserResolverService,
          },
        },
        {
          path: 'projects/:projectId/steps/:stepId/tasks/work',
          component: ProductionWorkspaceHostComponent,
          resolve: {
            currentUser: CurrentUserResolverService,
          },
          canActivate: [AuthGuard],
        },
        {
          path: 'projects/:projectId/samples/:sampleId/review',
          component: SamplingWorkspaceHostComponent,
          data: {
            initialPosition: 1,
          },
          resolve: {
            currentUser: CurrentUserResolverService,
          },
          canActivate: [AuthGuard],
        },
      ],
      { bindToComponentInputs: true },
    ),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
